export default __webpack_public_path__ + "static/media/gradprogram.efdd4d73.png";